import './_Button.scss'

/**
 * @component Button
 * @param {objects} params
 * @param {string | Node | Node[]} params.children
 * @param {function} params.onClick
 * @param {'submit' | 'button'} params.type
 */

const Button = ({ onClick, children, type = 'button' }) => {
  return (
    <button
      className='Button'
      onClick={onClick}
      type={type}
    >{children}</button>
  )
}

export default Button
